import React from 'react';

import state from '../zviz3/state';
import { ConnectState } from '../zviz3/Connect';
import Icon from '../elements/icon';

import {getSubsidies as getSubsidiesB} from './b';
import {getSubsidies as getSubsidiesC} from './c';
import {getSubsidies as getSubsidiesD} from './d';
import {getSubsidies as getSubsidiesE} from './e';
import {getSubsidies as getSubsidiesF} from './f';
import {getSubsidies as getSubsidiesG} from './g';
import {WarningBox} from '../elements/infoboxes';


function SectionH(props){

    if(state.get('answers.g') === true){
        const maatregelen = [getSubsidiesB(), getSubsidiesC(), getSubsidiesD(), getSubsidiesE()];

        let count = 0;
        for(const maatregel of maatregelen){
            if(maatregel.length > 0){
                count++;
            }
        }
        let result = '';
        if(count < 2){
            result = <WarningBox text="Om in aanmerking te komen voor subsidie moet u minimaal 2 energiebesparende maatregelen toepassen. Daaronder vallen: muurisolate, vloer/bodemisolatie, dakisolate en hoogrendementsglas. U heeft niet voldoende energiebesparende maatregelen getroffen om in aanmerking te komen." />
        }

        if(result === ''){
            const subsidies = [...getSubsidiesB(), ...getSubsidiesC(), ...getSubsidiesD(), 
                    ...getSubsidiesE(), ...getSubsidiesF(), ...getSubsidiesG()];
            result = <div>
                <h3>U komt in aanmerking voor de volgende subsidies:</h3>
                <ul>
                    {subsidies.map((text, k) => (
                        <li key={k}>{text}</li>
                    ))}
                </ul>
            </div>;
        }
        
        return <div className="seehi_section">
            <h2 className="seehi_iconHeader"><Icon type="subsidie" />Uw subsidie</h2>
            
            {result}

            <h3>Let op:</h3>
            <ul>
                <li>Er is een subsidieplafond voor deze regeling. Wacht dus niet te lang met uw aanvraag.</li>
                <li>De werkzaamheden moeten na 15 augustus 2019 beginnen.</li>
                <li>U kunt de subsidie aanvragen tot uiterlijk 1 januari 2021</li>
            </ul>

            <p>Benieuwd hoeveel subsidie u precies kunt krijgen? U kunt de rekentool gebruiken op 
                website <a href="https://www.rvo.nl/subsidies-regelingen/seeh/eigenaar-en-bewoner" target="_blank">SEEH voor woningeigenaren</a>. 
                U vindt daar ook alle voorwaarden terug. Wilt u nog meer maatregelen nemen? Dan is 
                wellicht het Zeer energiezuinig pakket (ZEP) voor u interessant. 
                Kijk op <a href="https://www.rvo.nl/subsidies-regelingen/seeh/eigenaar-en-bewoner" target="_blank">www.rvo.nl</a> voor 
                informatie over deze subsidie. Lees verder op deze pagina hoe u subsidie kunt 
                aanvragen.</p>
            
        </div>;
    }

    const steps = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];
    let progress = 0;
    for(let i = 0; i < steps.length; i++){
        if(state.get('answers.'+steps[i]) === true){
            progress = i+1;
        }
    }

    return <div style={{padding: '150px 0px 50px'}}>
        <h3>Uw voortgang</h3>
        <p>Beantwoord de bovenstaande vraag om door te gaan.</p>
        <div style={{width: '100%', height: '10px', border: '1px solid #39870c', borderRadius: '5px'}}>
            <div style={{width: (Math.max(2, Math.round(100*progress/steps.length)))+'%', height: '10px', backgroundColor: '#39870c', borderRadius: '5px'}}></div>
        </div>    
    </div>;
}

export default ConnectState(SectionH, 'answers');


// WEBPACK FOOTER //
// ./src/sections/h.js